import * as React from "react";
import { classNames } from "src/utils/utils";

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: "horizontal" | "vertical";
}

export const Separator = ({ className, ...props }: SeparatorProps) => {
  return (
    <div
      aria-orientation="horizontal"
      className={classNames("shrink-0 bg-border", "h-[1px] w-full", className)}
      {...props}
    />
  );
};
